import ActivityWithMyInstitution from './ActivityWithMyInstitution';

export default ActivityWithMyInstitution;
